var isBlockListItem = function isBlockListItem(block) {
  return ['unordered-list-item', 'ordered-list-item'].includes(block.getType());
};

export default isBlockListItem;